<template>
    <div class="container px-0" v-bind:class="!hide_options ? 'mt-4' : ''">
        <div class="row">
            <div class="col-12">
                <h5 class="text-secondary">Form Questions</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <draggable  v-model="questions">
                    <transition-group name="list-transition">
                        <div
                            v-for="(question, index) in questions"
                            class="flex-table flex-table-shadow"
                            :key="question.key"
                        >
                            <div class="flex-table--row flex-table--row--no-padding-y">
                                <div class="flex-table--cell">
                                    <img :src="'/svg/' + resource_group + '/drag.svg'" alt="">
                                </div>
                                <div class="flex-table--cell flex-table--cell-grow-always">
                                    <h5 class="text-secondary mb-0">{{question.question}}</h5>
                                </div>
                                <div class="flex-table--cell">
                                    <div class="badge badge--sm badge--light-grey">
                                        {{question.settings?.required ? 'required' : 'n/a'}}
                                    </div>
                                </div>
                                <div class="flex-table--cell">
                                    <div class="badge badge--sm badge--primary">
                                        {{getQuestionTypeText(question)}}
                                    </div>
                                </div>

                                <div class="flex-table--cell">
                                    <svg-image
                                        :src="'/svg/' + resource_group +'/more.svg'"
                                        width="20px"
                                        height="25px"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    ></svg-image>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <svg-image
                                            :src="'/svg/' + resource_group +'/edit.svg'"
                                            width="20px"
                                            height="20px"
                                            class="dropdown-item"
                                            :auto_hover="true"
                                            :spaced="true"
                                            @click="editQuestion(index)"
                                        >
                                            <span class="text-danger">Edit</span>
                                        </svg-image>
                                        <svg-image
                                            :src="'/svg/' + resource_group +'/bin.svg'"
                                            width="20px"
                                            height="20px"
                                            highlight="negative"
                                            class="dropdown-item"
                                            :auto_hover="true"
                                            :spaced="true"
                                            @click="removeQuestion(index)"
                                        >
                                            <span class="text-danger">Remove</span>
                                        </svg-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <button class="btn btn-secondary px-5" v-on:click="$refs.modal_question.openModal()">+ Question</button>
            </div>
        </div>

        <!--Options-->
        <div v-if="!hide_options" class="row mt-5">
            <!--Photos-->
            <div class="col-xl-6">
                <div class="flex-table flex-table-shadow">
                    <div class="flex-table--row flex-table--row--no-padding-y">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary mb-0">
                                Must upload photos
                            </h5>
                        </div>

                        <div class="flex-table--cell">
                            <label class="checkbox my-2 d-inline-flex" for="photos">
                                <input type="checkbox" v-model="photos" id="photos">
                                <div class="checkbox--check"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!--Signature-->
            <div class="col-xl-6">
                <div class="flex-table flex-table-shadow">
                    <div class="flex-table--row flex-table--row--no-padding-y">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary mb-0">
                                Must provide signature
                            </h5>
                        </div>

                        <div class="flex-table--cell">
                            <label class="checkbox my-2 d-inline-flex" for="signature">
                                <input type="checkbox" v-model="signature" id="signature">
                                <div class="checkbox--check"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!--Additional Comments-->
            <div class="col-xl-6">
                <div class="flex-table flex-table-shadow">
                    <div class="flex-table--row flex-table--row--no-padding-y">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary mb-0">
                                Must provide additional Comments
                            </h5>
                        </div>

                        <div class="flex-table--cell">
                            <label class="checkbox my-2 d-inline-flex" for="required">
                                <input type="checkbox" v-model="additional_comments" id="required">
                                <div class="checkbox--check"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!--Add operative with signature-->
            <div class="col-xl-6">
                <div class="flex-table flex-table-shadow">
                    <div class="flex-table--row flex-table--row--no-padding-y">
                        <div class="flex-table--cell flex-table--cell-grow-always">
                            <h5 class="text-secondary mb-0">
                                Add people with signature
                            </h5>
                        </div>

                        <div class="flex-table--cell">
                            <label class="checkbox my-2 d-inline-flex" for="add_operative_with_signature">
                                <input type="checkbox" v-model="add_operative_with_signature" id="add_operative_with_signature">
                                <div class="checkbox--check"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal ref="modal_question" title="Add question">
            <add-question-form
                ref="add_question"
                :questionData="editingQuestion"
                @createOrSaveQuestion="createOrSaveQuestion"
                :prefix_key="prefix_key"
                :index="editingQuestionIndex"
            ></add-question-form>
            <template v-slot:header>
            <div class="d-flex justify-content-between">
                <button class="btn btn-secondary px-4 mr-2" v-on:click="cancel()">Cancel</button>
                <button class="btn btn-primary px-4" v-on:click="saveQuestion()">Save</button>
            </div>
        </template>
        </modal>
    </div>
</template>

<script>
	import draggable from 'vuedraggable'
	import Modal from "../general_components/WideModal";
	import AddQuestionForm from "./AddQuestionForm";
	export default {
		name: "FormCustomTemplate",
		components: {AddQuestionForm, Modal, draggable},
		props: [
			'value',
			'form',
            'its_form_instance',
			'hide_options'
        ],
        data(){
			return {
				questions: [],
				additional_comments: false,
				photos: false,
				signature: false,
				fail_with_no: true,
                add_operative_with_signature: false,

                editingQuestion: {
                    settings:[],
                },
                editingQuestionIndex: null,

				prefix_key: 0,
            }
        },

        mounted(){
			if (this.form){
				let _this = this;
				if (_this.its_form_instance){
					_this.form.form.questions.forEach(function (question){
						question.key = _this.prefix_key ++;
						_this.questions.push(question);
					});
                }
				else {
					_this.form.questions.forEach(function (question){
						question.key = _this.prefix_key ++;
						_this.questions.push(question);
					});
                }
				_this.additional_comments = _this.form.settings.additional_comments;
				_this.photos = _this.form.settings.photos;
				_this.signature = _this.form.settings.signature;
				_this.fail_with_no = _this.form.settings.fail_with_no;
                _this.add_operative_with_signature = _this.form.settings.add_operative_with_signature;
            }
			this.save();
        },

        methods: {

            cancel(){
                this.editingQuestion = null;
                this.editingQuestionIndex = null;

                this.$refs.modal_question.closeModal(null, true);
            },
            saveQuestion(){
				this.$refs.add_question.save(null, true);
            },

            getQuestionTypeText(question){
                if (question.type === 'date') return 'Date and Time';
                if (question.type === 'yes_no') return 'Yes or No';
                if (question.type === 'free_text') return 'Free Text';
                if (question.type === 'dropdown' || question.type === 'dropdown_other') return 'Radio'; //cause reasons
                if (question.type === 'checkbox' || question.type === 'checkbox_other') return 'Checkbox';

                return 'Unknown';
            },
            createOrSaveQuestion(question){
				this.editingQuestion = null;
				this.editingQuestionIndex = null;
                if(question.index !== undefined && question.index !== null){
                    let data = {...this.questions[question.index], ...question};
                    delete data.index;

                    Vue.set(this.questions, question.index, data);

                    return;
                } else {
                    question.key = this.questions.length;
                }
				this.questions.push(question);
            },
            editQuestion(index){
                this.editingQuestion = Object.assign({}, this.questions[index]);
                this.editingQuestion.settings = Object.assign({}, this.questions[index].settings);
                this.editingQuestionIndex = index;
                this.$refs.modal_question.openModal();
            },
			removeQuestion(index){
				this.questions.splice(index, 1);
            },

			save(){
				let _build = Object.assign({}, this.value || {});

				_build.questions = this.questions;
				_build.additional_comments = this.additional_comments;
				_build.photos = this.photos;
				_build.signature = this.signature;
				_build.fail_with_no = this.fail_with_no;
                _build.add_operative_with_signature = this.add_operative_with_signature;

				this.$emit('input', _build);
            }
        },
        watch: {
			questions: {
				deep: true,
                handler(){ this.save() }
            },
            additional_comments(){ this.save() },
            photos(){ this.save() },
            signature(){ this.save() },
            fail_with_no(){ this.save() },
            add_operative_with_signature() { this.save() }
        }
	}
</script>
